const frequencyOptions: { [key: string]: string } = {
  monthly: 'Monthly',
  weekly: 'Weekly',
  'semi-monthly': 'Semi-Monthly',
  biweekly: 'Bi-Weekly',
  '3 months': 'Quarterly',
  '6 months': 'Semi-Annually',
  yearly: 'Annually',
  bimonthly: 'Bi-Monthly',
};

export default frequencyOptions;
